import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getIdArray } from 'helpers/dataHelpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import useStyles from './styles'
import Config from 'config'


const RoomsInput = (props) => {
  const localClasses = useStyles()
  const {
    error,
    helperText,
    setValue,
    defaultValue,
    rooms,
    required,
    single,
    variant,
    independent,
    additionalClasses,
    placeholder,
    InputLabelProps
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [localRooms, setRooms] = useState(rooms || [])

  useEffect(() => {
    if (rooms) {
      setRooms(rooms)
    }
  }, [rooms]) // eslint-disable-line react-hooks/exhaustive-deps

  const getRooms = () => {
    const url = `${apiUrl}rooms/get_simple_list/`
    axios.get(url).then((body) => {
      const { data } = body
      setRooms(data)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    if (independent) {
      getRooms()
    }
    if (defaultValue) {
      if (!single) {
        setValue(getIdArray(defaultValue))
      } else {
        setValue(defaultValue)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event, newValue) => {
    if (!single) {
      setValue(getIdArray(newValue))
    } else {
      setValue(newValue)
    }
  }

  const setDefaultValue = () => {
    if (defaultValue) {
      return defaultValue
    }
    if (single) {
      return null
    }
    return []
  }

  return (
    <Autocomplete
      onChange={handleChange}
      getOptionSelected={(option, value) => option.id === value.id}
      multiple={!single}
      filterSelectedOptions
      options={localRooms}
      className={`${localClasses.roomsAutocomlete} ${additionalClasses || ''}`}
      autoHighlight
      fullWidth
      defaultValue={setDefaultValue()}
      getOptionLabel={(room) => room.name}
      renderOption={(room) => (
        <React.Fragment>
          {room.name}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Rooms'
          variant={variant || 'outlined'}
          fullWidth
          required={!!required}
          error={error}
          helperText={helperText}
          name='rooms'
          InputLabelProps={InputLabelProps}
          color='secondary'
          placeholder={placeholder || 'Select rooms...'}
        />
      )}
    />
  )
}

export default RoomsInput
